<template>
  <div>
    <canvas ref="chart"></canvas>
    <p v-show="loading">Carregando</p>
  </div>
</template>
<script>
import Chart from 'chart.js';
import { uniq } from 'lodash';
import Colors from '@/utils/colors';
export default {
  name: 'PlanChart',
  data() {
    return {
      loading: false
    };
  },

  methods: {
    mountChart(payments = []) {
      this.loading = true;
      const labels = uniq(payments.map(p => p.plan_description));

      const data = [];
      labels.forEach(label => {
        const paymentsPlan = payments.filter(p => p.plan_description == label);
        data.push(paymentsPlan.length);
      });

      const chartDate = {
        type: 'horizontalBar',
        data: {
          labels: labels,
          datasets: [
            {
              backgroundColor: Colors.pallet(labels.length),
              label: 'Plano',
              data: data
            }
          ]
        },
        options: {
          legend: {
            display: false
          },
          scales: {
            y: {
              beginAtZero: true
            }
          }
        }
      };

      const canvas = this.$refs.chart;
      new Chart(canvas, chartDate);
      this.loading = false;
    }
  }
};
</script>
